import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChartPie } from "@mdi/js";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { Menu } from "./Menu";

export const SummaryMenu: React.FC<Menu> = memo(
  ({ handleClick, leftMenuOpen, user }) => {
    const { t } = useTranslation();

    if (
      !(
        user.roles_names.includes("View Vbuyer") ||
        user.roles_names.includes("View Service Negotiation")
      )
    ) {
      return null;
    }

    return (
      <HybridRouteListItemButtonLink
        caption="summary"
        isReact={false}
        name="summary"
        onClick={() => handleClick("summary")}
        title={t("menu.summary.title")}
        url="/vbuyer/summaries"
      >
        <ListItemIcon sx={{ minWidth: "2rem" }}>
          <Icon icon={mdiChartPie} />
        </ListItemIcon>
        {!!leftMenuOpen && (
          <ListItemText
            primary={t("menu.summary.title")}
            slotProps={{
              primary: {
                sx: {
                  fontSize: 14,
                },
              },
            }}
            sx={{ whiteSpace: "normal" }}
          />
        )}
      </HybridRouteListItemButtonLink>
    );
  },
);
